import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import {DateFixToGoLayout, GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {
    ThinCaretDownIcon,
    ThinClassIcon, ThinInfoIcon,
    ThinPrintIcon,
    ThinTimeIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {SelectClassModal} from "../classes/select-class-modal";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {AdminTuitionPaymentInfoModal} from "../students/payment-info-modal";
import {tuitionPaymentInterface} from "./tuition-payments";

interface logInterface{
    id:number,
    admin:string,
    title:string,
    createdAt:string,
}

export const AdminsFinanceLogsListScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [list, setList] = useState([] as logInterface[]);
    const fetchList = () => {
        setFilters({shown: ''});
        const t = {...time};
        console.log(t);
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        setLoaded(false);
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/finance/list-logs",
            {
                from: fromString,
                to: toString,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: logInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "سابقه عملیات | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'سابقه عملیات', url: '/admins/finance/logs'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>سابقه عملیات مالی</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    <div className="filter-buttons">
                                        <ClickOutsideDetector
                                            onClickOutside={() => {
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = '';
                                                    return x;
                                                });
                                            }}
                                            className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                            <button onClick={(e) => {
                                                e.stopPropagation();
                                                setFilters(v => {
                                                    let x = {...v};
                                                    x.shown = x.shown === 'time' ? '' : 'time';
                                                    return x;
                                                });
                                            }}>
                                                <ThinTimeIcon/>
                                                <span>زمان</span>
                                                <ThinCaretDownIcon/>
                                            </button>
                                            {
                                                filters.shown === 'time' ?
                                                    <div>
                                                        <label className="f-roboto">لطفا یک بازه
                                                            زمانی را انتخاب
                                                            کنید:</label>
                                                        <Calendar
                                                            value={time}
                                                            onChange={e => setTime(e)}
                                                            shouldHighlightWeekends
                                                            colorPrimary='#0a53be'
                                                            locale={'fa'}
                                                        />
                                                        <div className="text-end">
                                                            <button
                                                                className="filter-button-cta"
                                                                onClick={() => fetchList()}>
                                                                <span>اعمال تغییرات</span>
                                                            </button>
                                                        </div>
                                                    </div> :
                                                    null
                                            }
                                        </ClickOutsideDetector>
                                    </div>
                                </div>
                            </div>
                            <table className="table open-table table-striped table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>کاربر</th>
                                    <th>عملیات</th>
                                    <th>تاریخ</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((p, i) =>
                                        <tr key={"K39Er11K2QQPPcnS" + i}>
                                            <td style={{width:'5%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td style={{width:'10%'}}>{p.admin}</td>
                                            <td>{p.title}</td>
                                            <td style={{width:'20%'}}>{StringDigitsConvertToPersian(p.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(p.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
        </>
    );
};